/*
    If separator splits the string - get first letter of each group
    If string is NOT split - get the first two letters of the single string
*/
export const abbreviate = (string, separator = /[\s._-]/) => string
    .split(separator)
    .slice(0, 2)
    .map((str, _i, arr) => (arr.length > 1 ? str[0] : str.slice(0, 2)))
    .filter(Boolean)
    .join('')
    .toUpperCase();
export const abbreviateEmail = (email) => abbreviate(email.split('@')[0] || email);
